import moment from 'moment';

class DateUtils {
    public static formatDate (date: string | Date) {
        return moment(new Date(date)).format('YYYY-MM-DD');
    }
    public static formatDateTime (date: string | Date) {
        return moment(new Date(date)).format('YYYY-MM-DD HH:mm:ss');
    }
}

export default DateUtils;


// WEBPACK FOOTER //
// ./src/utils/DateUtils.ts